import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from './global.service';
import { CookieService } from 'ngx-cookie-service';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./global.service";
import * as i3 from "ngx-cookie-service";
var API_GET_AUTHORIZATIONS = '/authorization/get-authorizations';
var API_ADD_AUTHORIZATION = '/authorization/add-authorization';
var API_EDIT_AUTHORIZATION = '/authorization/edit-authorization';
var AuthorizationService = /** @class */ (function () {
    function AuthorizationService(http, globalService, cookieService) {
        this.http = http;
        this.globalService = globalService;
        this.cookieService = cookieService;
    }
    AuthorizationService.prototype.header = function () {
        return {
            headers: new HttpHeaders()
                .set('token', this.cookieService.get('_q'))
                .set('module', localStorage.getItem('authorization'))
        };
    };
    AuthorizationService.prototype.getAuthorizations = function (param) {
        return this.http.post(this.globalService.apiVersionHost + API_GET_AUTHORIZATIONS, param, this.header()).pipe(map(function (response) { return response; }));
    };
    AuthorizationService.prototype.addAuthorization = function (param) {
        return this.http.post(this.globalService.apiVersionHost + API_ADD_AUTHORIZATION, param, this.header()).pipe(map(function (response) { return response; }));
    };
    AuthorizationService.prototype.editAuthorization = function (param) {
        return this.http.post(this.globalService.apiVersionHost + API_EDIT_AUTHORIZATION, param, this.header()).pipe(map(function (response) { return response; }));
    };
    AuthorizationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthorizationService_Factory() { return new AuthorizationService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.GlobalService), i0.ɵɵinject(i3.CookieService)); }, token: AuthorizationService, providedIn: "root" });
    return AuthorizationService;
}());
export { AuthorizationService };
